import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myFinancial'
})
export class MyFinancialPipe implements PipeTransform {
  transform(nationalities: object[], value: string) {
    if (!value) {
      return nationalities
    }
    return nationalities.filter(item => item['order'] < 8);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/pipes/my-financial.pipe.ts